module.exports = __webpack_public_path__ + "media/images/line-5@1x-9a486e84dae12b7a46fb0fc5d9d4669b.png";